<template lang="pug">
bottom-modal(:id="modalId" width="w-xtra-large")
    span(slot="header-text") Add Tags

    template
        div(slot="body")
            .container
                .row
                    .col-md-12
                        table.table.table-striped.table-bordered.m-b-0.b-b
                            thead
                                tr
                                    th Name
                                    th.text-right Code
                                    th.text-center Select

                            tbody
                                template.p-l-5(v-for="tag in treeTag")
                                    tr.permission-group
                                        td {{ tag.name }}
                                        td.text-right {{ tag.code }}
                                        td.text-center
                                            label.md-check
                                                input(
                                                    type="checkbox"
                                                    :checked="checkedExistingTags(tag) || parentChecked(tag)"
                                                    @change="assignTags(tag)"
                                                )
                                                i.indigo

                                    template(v-for="tag in tag.children")
                                        tr.permission-group
                                            td &nbsp&nbsp {{ tag.name }}
                                            td.text-right {{ tag.code }}
                                            td.text-center
                                                label.md-check
                                                    input(
                                                        type="checkbox"
                                                        :checked="checkedExistingTags(tag) || parentChecked(tag)"
                                                        :disabled="parentChecked(tag)"
                                                        @change="assignTags(tag)"
                                                    )
                                                    i.indigo

                                        template(v-for="tag in tag.children")
                                            tr.permission-group
                                                td &nbsp&nbsp&nbsp&nbsp {{ tag.name }}
                                                td.text-right {{ tag.code }}
                                                td.text-center
                                                    label.md-check
                                                        input(
                                                            type="checkbox"
                                                            :checked="checkedExistingTags(tag) || parentChecked(tag)"
                                                            :disabled="parentChecked(tag)"
                                                            @change="assignTags(tag)"
                                                        )
                                                        i.indigo

                                            template(v-for="tag in tag.children")
                                                tr
                                                    td &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp {{ tag.name }}
                                                    td.text-right {{ tag.code }}
                                                    td.text-center
                                                        label.md-check
                                                            input(
                                                                type="checkbox"
                                                                :checked="checkedExistingTags(tag) || parentChecked(tag)"
                                                                :disabled="parentChecked(tag)"
                                                                @change="assignTags(tag)"
                                                            )
                                                            i.indigo
</template>

<script>
import { mapActions, mapState } from 'vuex';

const TableName = 'VUETABLE_TAGS';
export default {
    data() {
        return {
            tax: {},
            modalId: 'modalTagTax',
            tableName: TableName,
            columns: ['select', 'name', 'code'],
        };
    },

    computed: {
        ...mapState('tag', ['treeTag']),
    },

    mounted() {
        this.getTagTree();
    },

    methods: {
        ...mapActions('tag', ['getTagTree']),

        showModal() {
            $(`#${this.modalId}`).modal('show');
        },

        hideModal() {
            $(`#${this.modalId}`).modal('hide');
        },

        registerTax(tax) {
            this.tax = tax;
        },

        assignTags(row) {
            const index = this.findIndex(row.id);

            if (index !== -1) {
                this.tax.tags.splice(index, 1);
            } else {
                this.tax.tags.push(row);
            }

            this.unassignChildTags(row);
        },

        unassignChildTags(row) {
            if (row.children) {
                row.children.map(tag => {
                    const index = this.findIndex(tag.id);

                    if (index !== -1) {
                        this.tax.tags.splice(index, 1);
                        this.unassignChildTags(tag);
                    }
                });
            }
        },

        checkedExistingTags(row) {
            if (this.tax.tags) {
                return this.tax.tags.map(p => p.id).includes(row.id);
            }
        },

        parentChecked(row) {
            if (this.tax.tags) {
                const index = this.findIndex(row.parent_id);

                if (index !== -1) {
                    return true;
                }

                if (row.parent) {
                    return this.parentChecked(row.parent);
                }
            }
        },

        findIndex(id) {
            return this.tax.tags.findIndex(p => p.id === id);
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../../sass/variables';

thead {
    background-color: #e9ecef;
}

.permission-group {
    background: $light-grey;

    td {
        font-weight: bold;
    }
}

.permission-name,
.sub-name {
    min-height: 25px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/tax/add-tags-form.vue